module.exports = __webpack_public_path__ + "h5/img/noExpireCoupon.c09eec08.png";